import ServiceEndpoints from "../ServiceEndpoints";

export async function getTotalAssessmentsForDeletion(fromDate: string, toDate: string, token: string) {
    const url = `${ServiceEndpoints.GetTotalAssessmentsForDeletion}?fromDate=${fromDate}&toDate=${toDate}`;
    const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` }
    });
    if (!res.ok) throw new Error("Failed to fetch total assessments for deletion");
    return res.json();
}

export async function bulkDeleteAssessments(fromDate: string, toDate: string, token: string) {
    const url = `${ServiceEndpoints.BulkDeleteAssessments}?fromDate=${fromDate}&toDate=${toDate}`;
    const res = await fetch(url, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` }
    });
    return res;
}

export async function downloadAssessmentsForDeletion(fromDate: string, toDate: string, token: string) {
    const url = `${ServiceEndpoints.DownloadAssessmentsForDeletion}?fromDate=${fromDate}&toDate=${toDate}`;
    const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` }
    });
    if (!res.ok) throw new Error("Failed to download assessments Excel file");
    return res.blob();
}